module.exports = __webpack_public_path__ + "static/media/5-10.829d0a08.mp3";